/**
 * The page's one call, kept out of the component.
 *
 * CLAUDE.md: components and hooks call the app's API layer, never axios directly. The URL, the
 * parameter and the response shape live here, and the page renders.
 */
import axios from 'axios'
import type { BoxTruckZipAnalytics } from '@numeo/types-main-mobile'
import { apiErrorMessage } from '@/api/errorMessage'

/** One of `ANALYTICS_WINDOW_DAYS`, which the server validates against the same constant. 0 is all time. */
export async function fetchBoxTruckZipAnalytics(days: number, signal?: AbortSignal): Promise<BoxTruckZipAnalytics> {
    try {
        const res = await axios.get<{ success: boolean; data: BoxTruckZipAnalytics }>('/gluon/box-truck-zip-analytics', { params: { days }, signal })
        return res.data.data
    } catch (error) {
        // `apiErrorMessage`, not another copy of this catch block — see `api/errorMessage.ts`.
        throw new Error(apiErrorMessage(error))
    }
}
